import { render, staticRenderFns } from "./myWork.vue?vue&type=template&id=8a8eb17a&scoped=true"
import script from "./myWork.vue?vue&type=script&lang=js"
export * from "./myWork.vue?vue&type=script&lang=js"
import style0 from "./myWork.vue?vue&type=style&index=0&id=8a8eb17a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8eb17a",
  null
  
)

export default component.exports